import React from 'react';
import { GameSection } from '@pascal/pascal-core';
import { GameHolder } from '../components/gameHolder';
import Keno from '../games/keno';
import { BetBlock } from '../games/keno/betBlock';
import RightSide from '../components/rightSide';
import { HeaderWr } from '../components/header';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../core/constants/betResponseCodes';

function Web() {
  return (
    <>
      <HeaderWr />
      <GameHolder>
        <GameSection
          haveNotification
          AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
          AdditionalResponseCode={AdditionalResponseCode}
          AdditionalErrorMessages={AdditionalErrorMessages}
        >
          <Keno />
          <BetBlock />
        </GameSection>
      </GameHolder>
      <RightSide />
    </>
  );
}

export default Web;
